import React from "react";
import ReactTooltip from "react-tooltip";

//credits https://materialdesignicons.com/icon/cursor-default-outline

export default function IconCursor() {
	return (
		<>
			<ReactTooltip effect="solid" className="small-tip" id="icon-cursor" />
			<svg data-for="icon-cursor" width={24} height={24} stroke="none" fill="currentColor" data-tip="Point Selection">
				<path d="M10.07,14.27C10.57,14.03 11.16,14.25 11.4,14.75L13.7,19.74L15.5,18.89L13.19,13.91C12.95,13.41 13.17,12.81 13.67,12.58L13.95,12.5L16.25,12.05L8,5.12V15.9L9.82,14.43L10.07,14.27M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19A1,1 0 0,1 6,18V3A1,1 0 0,1 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z" />
			</svg>
		</>
	);
}
